import {memo} from 'react';
import {cn} from '@chekinapp/ui';
import styles from './arrival.module.css';

type Props = {
  narrow?: boolean;
  scrim?: boolean;
};

const PropertyScene = memo(function PropertyScene({narrow, scrim = true}: Props) {
  return (
    <div className={cn('pointer-events-none absolute inset-0', styles.sceneIn)}>
      <div className={cn(styles.photo, narrow && styles.photoCanvas)} />
      <div className={styles.grain} />
      {scrim && <div className={styles.scrim} />}
    </div>
  );
});

export {PropertyScene};
